module.exports = __webpack_public_path__ + "img/apple.f8768f02.svg";